export default __webpack_public_path__ + "media/design-system/form/assets/password-61b8cc6031f0435e993bb3858bad5550.svg";